export default "__VITE_ASSET__04u_ctjI__"